import { useContext, createContext } from 'react';

// Rail drawer state shared between the layout and the page header below lg.
export const InsightsShellContext = createContext({ railOpen: false, setRailOpen: () => {} });

export const useInsightsShell = () => useContext(InsightsShellContext);
